import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Modal, Form, Input, InputNumber,
} from 'antd';
import { requestUpdatePurchase } from '../../../../state/ui/purchase/purchaseCreditsUiActions';
import { selectUpdatePurchaseRequest } from '../../../../state/ui/purchase/purchaseCreditsUiReducer';


const DescriptionField = ({ form }) => {
  const intl = useIntl();

  return (
    <Form.Item required label={<FormattedMessage id="braintreeId" />}>
      { form.getFieldDecorator('braintreeId', {
        rules: [{ required: true, message: intl.formatMessage({ id: 'validationEmpty' }) }],
      })(
        <Input
          type="text"
          maxLength={20}
          allowClear
          placeholder={intl.formatMessage({ id: 'enter' })}
        />,
      )}
    </Form.Item>
  );
};

const CommissionField = ({ form, currencyCode }) => {
  const intl = useIntl();

  return (
    <Form.Item label={<FormattedMessage id="commission" values={{ currencyCode }} />}>
      { form.getFieldDecorator('commission', {})(
        <InputNumber
          style={{ width: '300px' }}
          max={10000000000}
          precision={2}
          placeholder={intl.formatMessage({ id: 'enter' })}
        />,
      )}
    </Form.Item>
  );
};

/**
 * A modal for editing a package that is beinged confirmed.
 * @param {object} props The react props.
 * @param {object} props.confirmingPackage The package that is being updated.
 */
const EditConfirmingPackage = Form.create({ name: 'edit-damage-area' })(({
  form, confirmingPackage, onCancel, ...rest
}) => {
  // Redux Actions
  const dispatch = useDispatch();
  const updatePurchase = (id, commission, braintreeId, groupId) => dispatch(requestUpdatePurchase(id, commission, braintreeId, groupId));

  // Redux State
  const updatePurchaseRequest = useSelector(selectUpdatePurchaseRequest);
  const isUpdating = !!(updatePurchaseRequest && updatePurchaseRequest.isLoading);

  const submitForm = async () => {
    try {
      const values = await form.validateFields();

      await updatePurchase(confirmingPackage.code, values.commission, values.braintreeId, confirmingPackage.userGroupId);
      onCancel();
    } catch (_) {
      // Nothing to do. Errors are displayed visually.
    }
  };

  if (!confirmingPackage) return <></>;

  return (
    <Modal
      title={<FormattedMessage id="updateConfirmingPackage" />}
      okText={<FormattedMessage id="save" />}
      onOk={() => { submitForm(); }}
      onCancel={onCancel}
      confirmLoading={isUpdating}
      {...rest}
    >
      {/* <ViaValidationAlert validationError={saveValidationError} /> */}
      <Form layout="vertical" onSubmit={(e) => { e.preventDefault(); submitForm(); }}>
        <DescriptionField form={form} />
        <CommissionField form={form} currencyCode={confirmingPackage.currencyCode} />
      </Form>
    </Modal>
  );
});

EditConfirmingPackage.propTypes = {
  confirmingPackage: PropTypes.shape({}),
};

EditConfirmingPackage.defaultProps = {
  confirmingPackage: undefined,
};

export default EditConfirmingPackage;
